// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"128":"css/app.6698","1291":"css/admin-app.6698"}[chunkId] + ".css";
};